import type { AxiosInstance } from 'axios';
import type { RewardAction, RewardActionType } from '@/types';
import baseAxios from '@/helpers/forms/axios';

interface RewardsApi {
    fetchActionStatuses: () => Promise<RewardAction[]>
    requestVerification: (action: RewardActionType) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): RewardsApi => ({
    fetchActionStatuses: async (): Promise<RewardAction[]> => {
        const response = await axios.get<RewardAction[]>('/rewards/actions');
        return response.data;
    },
    requestVerification: async (action: RewardActionType): Promise<void> => {
        await axios.post('/rewards/action/new', { action });
    },
});
